import { render, staticRenderFns } from "./Mailjet.vue?vue&type=template&id=d4dde90e&"
import script from "./Mailjet.vue?vue&type=script&lang=js&"
export * from "./Mailjet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports